import { array, literal, struct } from 'io-ts/Decoder';

import { Type as Frame } from '../frame/Type';

/**
 * Sent when a frames snapshot is sent to the AI.
 */
export const FramesSnapshot = struct({
	type: literal('frames-snapshot'),
	frames: array(Frame),
});
